/**
 * Seinäpinta Cart Price Corrector
 * This script corrects the displayed prices in cart for custom calculated seinäpinta products
 */

(function () {
  "use strict";

  console.log("=== SEINÄPINTA CART PRICE CORRECTOR STARTING ===");

  function correctCartPrices() {
    console.log("Starting Seinäpinta price correction...");

    // Find all cart items, but only process ones with seinäpinta calculated prices
    const cartItems = document.querySelectorAll("[data-cart-item], .cart-item");

    if (cartItems.length === 0) {
      console.log("No cart items found");
      return;
    }

    let correctionsMade = false;

    cartItems.forEach((item, index) => {
      // First check if this item has seinäpinta calculated price data
      const calculatedPriceElement = item.querySelector(
        '[data-line-item-property="_calculated_price"]'
      );
      const calculatedPriceDisplayElement = item.querySelector(
        '[data-line-item-property="_calculated_price_display"]'
      );

      // Only process items that have our specific seinäpinta price calculation properties
      if (!calculatedPriceElement || !calculatedPriceDisplayElement) {
        return; // Skip this item - it's not a seinäpinta product
      }

      console.log(`Processing seinäpinta cart item ${index}:`, item);

      const originalPriceElement = item.querySelector(
        '[data-line-item-property="_original_price"]'
      );

      const calculatedPrice = calculatedPriceElement.getAttribute(
        "data-calculated-price"
      );
      const calculatedPriceDisplay = calculatedPriceDisplayElement.getAttribute(
        "data-calculated-price-display"
      );
      const originalPrice = originalPriceElement
        ? originalPriceElement.getAttribute("data-original-price")
        : null;

      console.log("Found seinäpinta calculated price data:", {
        calculatedPrice,
        calculatedPriceDisplay,
        originalPrice,
      });

      // Find price elements to update
      const priceElements = item.querySelectorAll(
        [
          ".cart-item__selling-price",
          ".theme-money",
          "[data-cart-item-price]",
          "[data-line-item-price]",
          ".price",
          ".money",
        ].join(", ")
      );

      if (priceElements.length > 0 && calculatedPriceDisplay) {
        console.log(
          `Updating ${priceElements.length} price elements with: ${calculatedPriceDisplay}`
        );

        priceElements.forEach((priceEl) => {
          // Only update main price elements, not struck-out prices
          if (
            !priceEl.closest(".struck-out-price") &&
            !priceEl.hasAttribute("data-price-corrected") &&
            !priceEl.textContent.includes("_calculated_price")
          ) {
            const originalText = priceEl.textContent.trim();
            priceEl.textContent = calculatedPriceDisplay;
            priceEl.setAttribute("data-price-corrected", "true");
            priceEl.setAttribute("data-seinapinta-corrected", "true"); // Mark as seinäpinta correction

            // Update data attributes if they exist
            if (calculatedPrice) {
              if (priceEl.hasAttribute("data-cart-item-price")) {
                priceEl.setAttribute("data-cart-item-price", calculatedPrice);
              }
              if (priceEl.hasAttribute("data-line-item-price")) {
                priceEl.setAttribute("data-line-item-price", calculatedPrice);
              }
            }

            console.log(
              `Updated seinäpinta price from "${originalText}" to "${calculatedPriceDisplay}"`
            );
            correctionsMade = true;
          }
        });

        // Mark the item as processed
        item.setAttribute("data-seinapinta-price-corrected", "true");
      }
    });

    if (correctionsMade) {
      console.log("Seinäpinta price corrections made, updating totals...");
      setTimeout(correctCartTotals, 50);
    }
  }

  function correctCartTotals() {
    console.log("Correcting cart totals for seinäpinta products...");

    // Calculate total corrections needed - only for seinäpinta products
    let totalCorrectionCents = 0;
    const correctedItems = document.querySelectorAll(
      '[data-seinapinta-price-corrected="true"]'
    );

    if (correctedItems.length === 0) {
      console.log("No seinäpinta items found for total correction");
      return;
    }

    correctedItems.forEach((item) => {
      const calculatedPriceElement = item.querySelector(
        '[data-line-item-property="_calculated_price"]'
      );
      const originalPriceElement = item.querySelector(
        '[data-line-item-property="_original_price"]'
      );

      if (calculatedPriceElement && originalPriceElement) {
        const calculatedPrice =
          parseInt(
            calculatedPriceElement.getAttribute("data-calculated-price")
          ) || 0;
        const originalPrice =
          parseInt(originalPriceElement.getAttribute("data-original-price")) ||
          0;
        const difference = calculatedPrice - originalPrice;

        totalCorrectionCents += difference;
        console.log("Seinäpinta item correction:", {
          calculatedPrice,
          originalPrice,
          difference,
        });
      }
    });

    if (totalCorrectionCents === 0) {
      console.log("No seinäpinta total corrections needed");
      return;
    }

    console.log(
      `Seinäpinta total correction needed: ${totalCorrectionCents} cents (${(
        totalCorrectionCents / 100
      ).toFixed(2)} €)`
    );

    // Focus only on specific cart total/subtotal selectors
    const totalSelectors = [
      ".cart-total",
      ".cart__total",
      ".cart-subtotal",
      ".cart__subtotal",
      "[data-cart-total]",
      "[data-cart-subtotal]",
      ".cart-footer__total",
      ".cart-drawer__total",
      ".drawer__total",
      ".subtotal",
      ".totals__subtotal",
      ".totals__total",
      ".cart-summary__total",
      ".cart__footer .total",
      ".cart-drawer__footer .total",
    ];

    // Find total elements using more conservative approach
    const potentialTotalElements = [];

    // Only use specific selectors for cart totals
    totalSelectors.forEach((selector) => {
      const totalElements = document.querySelectorAll(selector);
      totalElements.forEach((el) => {
        if (
          el.textContent?.includes("€") &&
          !el.hasAttribute("data-seinapinta-total-corrected") &&
          !el.closest(".cart-item") && // Not inside individual cart items
          !el.textContent.includes("_calculated_price") &&
          !el.closest("script") && // Not inside script tags
          !el.closest("style") && // Not inside style tags
          el.tagName !== "SCRIPT" && // Not a script element
          el.tagName !== "STYLE"
        ) {
          // Not a style element

          // Check text length to avoid processing large chunks of text/code
          const text = el.textContent.trim();
          if (
            text.length < 500 && // Reasonable length for a price display
            (text.match(/€/g) || []).length <= 3
          ) {
            // Not too many euro symbols
            potentialTotalElements.push(el);
          }
        }
      });
    });

    console.log(
      `Found ${potentialTotalElements.length} potential total elements to update`
    );

    potentialTotalElements.forEach((totalEl, index) => {
      const currentText = totalEl.textContent.trim();

      // Additional safety checks
      if (
        !currentText ||
        !currentText.includes("€") ||
        totalEl.hasAttribute("data-seinapinta-total-corrected") ||
        currentText.includes("_calculated_price") ||
        currentText.length > 100 || // Skip very long text
        (currentText.match(/€/g) || []).length > 2 || // Skip if too many euro symbols
        currentText.includes("console.log") || // Skip if contains code
        currentText.includes("function") || // Skip if contains code
        currentText.includes("var ") || // Skip if contains code
        currentText.includes("const ") || // Skip if contains code
        currentText.includes("let ") || // Skip if contains code
        totalEl.closest("script") || // Skip script elements
        totalEl.tagName === "SCRIPT"
      ) {
        // Skip script tags
        return;
      }

      console.log(
        `Checking total element ${index}: "${currentText.substring(0, 50)}..."`
      );

      // Enhanced price matching - more flexible patterns
      const pricePatterns = [
        /([\d\s]+,\d{2})\s*€/, // 12,34 €
        /€\s*([\d\s]+,\d{2})/, // € 12,34
        /([\d\s]+,\d{2})€/, // 12,34€
        /([\d\s]+\.\d{2})\s*€/, // 12.34 €
        /€\s*([\d\s]+\.\d{2})/, // € 12.34
        /([\d\s]+\.\d{2})€/, // 12.34€
        /([\d\s]+)\s*€/, // 12 €
        /€\s*([\d\s]+)/, // € 12
        /([\d\s]+)€/, // 12€
      ];

      let priceMatch = null;
      for (const pattern of pricePatterns) {
        priceMatch = currentText.match(pattern);
        if (priceMatch) break;
      }

      if (priceMatch) {
        let priceString = priceMatch[1].replace(/\s/g, "");

        // Handle both comma and dot as decimal separator
        if (priceString.includes(",")) {
          priceString = priceString.replace(",", ".");
        }

        const currentPrice = parseFloat(priceString);

        if (!isNaN(currentPrice) && currentPrice > 0 && currentPrice < 10000) {
          // Reasonable price range
          const correctedPrice = currentPrice + totalCorrectionCents / 100;
          let formattedPrice = correctedPrice.toFixed(2);

          // Use comma as decimal separator for display (European format)
          formattedPrice = formattedPrice.replace(".", ",");

          // Preserve the original format structure
          const newText = currentText.replace(
            priceMatch[0],
            formattedPrice + " €"
          );

          totalEl.textContent = newText;
          totalEl.setAttribute("data-seinapinta-total-corrected", "true");

          console.log(
            `Updated seinäpinta total from "${currentText}" to "${newText}"`
          );
        }
      }
    });
  }

  function initCartPriceCorrection() {
    console.log("Initializing cart price correction...");

    // Debounce function to prevent too frequent corrections
    let correctionTimeout;
    function debouncedCorrection() {
      clearTimeout(correctionTimeout);
      correctionTimeout = setTimeout(() => {
        correctCartPrices();
        correctCartTotals();
      }, 150);
    }

    // Correct prices immediately
    debouncedCorrection();

    // Set up observers for dynamic cart updates
    const cartContainer =
      document.querySelector(
        ".cart, #cart, [data-cart], .cart-drawer, .drawer__content, main"
      ) || document.body;

    if (cartContainer && "MutationObserver" in window) {
      const observer = new MutationObserver(function (mutations) {
        let shouldCorrect = false;

        mutations.forEach((mutation) => {
          if (
            mutation.type === "childList" ||
            mutation.type === "characterData"
          ) {
            // Check if cart content changed or any price-related content
            if (
              mutation.target.closest(
                '.cart, [data-cart], .cart-item, [class*="cart"], [class*="total"], [class*="price"]'
              ) ||
              mutation.target.textContent?.includes("€") ||
              (mutation.addedNodes &&
                Array.from(mutation.addedNodes).some(
                  (node) =>
                    node.textContent?.includes("€") ||
                    (node.nodeType === 1 &&
                      node.querySelector &&
                      node.querySelector(
                        '[class*="cart"], [class*="total"], [class*="price"]'
                      ))
                ))
            ) {
              shouldCorrect = true;
            }
          }
        });

        if (shouldCorrect) {
          console.log("Cart or price content changed, re-correcting prices...");
          debouncedCorrection();
        }
      });

      observer.observe(cartContainer, {
        childList: true,
        subtree: true,
        characterData: true,
      });

      console.log("Set up mutation observer for cart changes");
    }

    // Also listen for various cart-related events
    const cartEvents = [
      "cart:updated",
      "cart:open",
      "cart:close",
      "cart:refresh",
      "cartUpdated",
      "cartDrawerOpen",
      "ajaxCart:updated",
    ];

    cartEvents.forEach((eventName) => {
      document.addEventListener(eventName, function () {
        console.log(`${eventName} event detected`);
        debouncedCorrection();
      });
    });

    // Listen for AJAX completions that might update cart
    const originalXHROpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url, ...args) {
      if (url.includes("/cart") || url.includes("cart.js")) {
        this.addEventListener("load", function () {
          console.log("Cart AJAX request completed");
          debouncedCorrection();
        });
      }
      return originalXHROpen.apply(this, [method, url, ...args]);
    };

    // Also intercept fetch requests
    const originalFetch = window.fetch;
    window.fetch = function (url, ...args) {
      const promise = originalFetch.apply(this, [url, ...args]);

      if (
        typeof url === "string" &&
        (url.includes("/cart") || url.includes("cart.js"))
      ) {
        promise.then(() => {
          console.log("Cart fetch request completed");
          debouncedCorrection();
        });
      }

      return promise;
    };
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCartPriceCorrection);
  } else {
    setTimeout(initCartPriceCorrection, 100);
  }

  console.log(
    "=== SEINÄPINTA CART PRICE CORRECTOR INITIALIZED (ENHANCED VERSION) ==="
  );
})();
